(() => {
  const root = document.querySelector('[data-rn-landing]');
  if (!root) return;

  const $ = (sel) => root.querySelector(sel);
  const form = root.querySelector('form');
  const openBtn = $('[data-rn-open]');
  const card = $('[data-rn-card]');
  const sent = $('[data-rn-sent]');
  const submitBtn = $('[data-rn-submit]');
  const submitLabel = $('[data-rn-submit-label]');
  const inputs = {
    name: $('[data-rn-input="name"]'),
    email: $('[data-rn-input="email"]'),
    message: $('[data-rn-input="message"]'),
  };
  const STORE_KEY = 'rn-contact-sent';
  let tried = false;

  const validate = () => {
    const e = {};
    if (!inputs.name.value.trim()) e.name = 'Add your name.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputs.email.value.trim())) e.email = 'Enter a valid email.';
    if (inputs.message.value.trim().length < 10) e.message = 'Say a little more (10+ characters).';
    return e;
  };

  const showErrors = (errors) => {
    for (const key of Object.keys(inputs)) {
      const msg = errors[key] || '';
      inputs[key].setAttribute('aria-invalid', msg ? 'true' : 'false');
      $(`[data-rn-error="${key}"]`).textContent = msg;
    }
  };

  const setSending = (sending) => {
    submitLabel.textContent = sending ? 'Sending…' : 'Send message';
    submitBtn.setAttribute('aria-disabled', sending ? 'true' : 'false');
  };

  // Bring the card into view if any of it is off-screen: top 20px from the top of the viewport,
  // or bottom-aligned when the whole card fits. Measured from the form (the card's untransformed
  // container) because the card's entrance animation shifts and scales it.
  const reveal = () => {
    const bottom = form.getBoundingClientRect().bottom;
    const height = card.offsetHeight;
    const top = bottom - height;
    const gap = 24;
    if (top >= gap && bottom <= window.innerHeight - gap) return;
    const fits = height + gap * 2 <= window.innerHeight;
    const delta = fits ? bottom - (window.innerHeight - gap) : top - gap;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollBy({ top: delta, behavior: reduce ? 'auto' : 'smooth' });
  };

  const open = () => {
    openBtn.hidden = true;
    openBtn.setAttribute('aria-expanded', 'true');
    card.hidden = false;
    reveal();
    inputs.name.focus({ preventScroll: true });
  };

  const close = () => {
    card.hidden = true;
    openBtn.hidden = false;
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus();
  };

  openBtn.addEventListener('click', open);
  $('[data-rn-close]').addEventListener('click', close);

  for (const input of Object.values(inputs)) {
    input.addEventListener('input', () => { if (tried) showErrors(validate()); });
  }

  // Returns true (and shows errors) when the form must not be sent.
  const block = (ev) => {
    tried = true;
    const errors = validate();
    showErrors(errors);
    if (!Object.keys(errors).length) return false;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    inputs[Object.keys(errors)[0]].focus();
    return true;
  };

  // Stop invalid sends before Shopify's spam-protection script sees them: it submits the form
  // itself, even when the submit event was cancelled. Pressing Enter also fires this click.
  submitBtn.addEventListener('click', block, true);

  // Capture phase on window runs before any listener on the form itself.
  window.addEventListener('submit', (ev) => {
    if (ev.target !== form || block(ev)) return;
    // Valid: let the submit continue so Shopify's spam protection (hCaptcha) can run.
    setSending(true);
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        first: inputs.name.value.trim().split(/\s+/)[0],
        email: inputs.email.value.trim(),
      }));
    } catch (_) {}
  }, true);

  // Restore the button label when returning via back/forward cache.
  window.addEventListener('pageshow', () => setSending(false));

  // Success page (rendered by Liquid after Shopify accepts the post): personalise it.
  if (!sent.hidden) {
    let data = null;
    try {
      data = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      sessionStorage.removeItem(STORE_KEY);
    } catch (_) {}
    if (data) {
      if (data.first) $('[data-rn-first]').textContent = `, ${data.first}`;
      if (data.email) $('[data-rn-email]').textContent = ` at ${data.email}`;
    }
  }
})();
